import type { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useLayoutEffect } from 'react';

import { BusinessModelsBlock } from '../components/landingV4/BusinessModelsBlock';
import { FAQBlock } from '../components/landingV4/FAQBlock';
import { FeedbackBlock } from '../components/landingV4/FeedbackBlock';
import { FirstScreen } from '../components/landingV4/FirstScreen';
import { Footer } from '../components/landingV4/Footer';
import { Header } from '../components/landingV4/Header';
import { PaymentsBlock } from '../components/landingV4/PaymentsBlock';
import { PayoutsBlock } from '../components/landingV4/PayoutsBlock';
import { ProtectBlock } from '../components/landingV4/ProtectBlock';
import { ScaleBlock } from '../components/landingV4/ScaleBlock';
import { SnackbarProvider } from '../components/landingV4/SnackbarProvider';
import { EmptyLayout } from '../components/layout/MainLayout/EmptyLayout';

import { NextPageWithLayout } from './_app';

const Page: NextPageWithLayout = () => {
  // Remove when v4 is fully released
  useLayoutEffect(() => {
    document.documentElement.classList.add('v4');
  }, []);

  return (
    <SnackbarProvider>
      <Header />
      <FirstScreen />
      <PaymentsBlock />
      <BusinessModelsBlock />
      <ScaleBlock />
      <PayoutsBlock />
      <ProtectBlock />
      <FAQBlock />
      <FeedbackBlock />
      <Footer />
    </SnackbarProvider>
  );
};

Page.getLayout = (page) => <EmptyLayout withFloatMenu={false}>{page}</EmptyLayout>;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  };
};

export default Page;
